import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false;

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin);

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

import store from "@/store";
import router from "@/./router";
import PageDateModel from "./PageDateModel";


store.state.pages=PageDateModel.all();

window.toto=new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
